import { ArrowUpLeft } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

interface GroupElementHeaderProps {
  callback?: () => void;
  label: string;
  disabled?: boolean;
}

export default function GroupElementHeader(groupElementHeader: GroupElementHeaderProps) {
  const { disabled, label, callback } = groupElementHeader;
  return (
    <header className={'flex items-center justify-between gap-2 p-4'}>
      <h3 className={'w-full truncate text-lg font-semibold'}>{label}</h3>
      {callback && (
        <Badge size={'sm'} variant={'muted'} className="cursor-pointer" asChild>
          <button type="button" disabled={disabled} onClick={callback}>
            <ArrowUpLeft /> Więcej
          </button>
        </Badge>
      )}
    </header>
  );
}
